var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayforlead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1704_12164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5C8.02682 8.5 8.04887 8.52026 8.05176 8.54688L8.11133 9.13477C8.17032 9.72468 8.20316 10.0682 8.27539 10.3711C8.67123 12.0303 9.97143 13.3233 11.6328 13.71C11.9361 13.7805 12.2798 13.8115 12.8701 13.8672L13.4395 13.9209C13.4735 13.9241 13.4999 13.9531 13.5 13.9873C13.5 14.0213 13.4743 14.0502 13.4404 14.0537L12.8672 14.1104C12.2582 14.1713 11.9035 14.2062 11.5908 14.2822C9.95643 14.68 8.67999 15.9564 8.28223 17.5908C8.20616 17.9035 8.17125 18.2582 8.11035 18.8672L8.05176 19.4531C8.04887 19.4797 8.02682 19.5 8 19.5C7.97318 19.5 7.95113 19.4797 7.94824 19.4531L7.88965 18.8672C7.82875 18.2582 7.79384 17.9035 7.71777 17.5908C7.32001 15.9564 6.04357 14.68 4.40918 14.2822C4.09645 14.2062 3.74184 14.1713 3.13281 14.1104L2.55957 14.0537C2.52573 14.0502 2.5 14.0213 2.5 13.9873C2.50007 13.9531 2.5265 13.9241 2.56055 13.9209L3.12988 13.8672C3.72017 13.8115 4.06391 13.7805 4.36719 13.71C6.02857 13.3233 7.32877 12.0303 7.72461 10.3711C7.79684 10.0682 7.82968 9.72468 7.88867 9.13477L7.94824 8.54688C7.95113 8.52026 7.97318 8.5 8 8.5Z",
    stroke: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6894 4.24254C17.725 4.1 17.8531 4 18 4C18.1469 4 18.275 4.1 18.3106 4.24254L18.4341 4.7364C18.7824 6.12969 19.8703 7.21758 21.2636 7.5659L21.7575 7.68937C21.9 7.725 22 7.85307 22 8C22 8.14693 21.9 8.275 21.7575 8.31063L21.2636 8.4341C19.8703 8.78242 18.7824 9.87031 18.4341 11.2636L18.3106 11.7575C18.275 11.9 18.1469 12 18 12C17.8531 12 17.725 11.9 17.6894 11.7575L17.5659 11.2636C17.2176 9.87031 16.1297 8.78242 14.7364 8.4341L14.2425 8.31063C14.1 8.275 14 8.14693 14 8C14 7.85307 14.1 7.725 14.2425 7.68937L14.7364 7.5659C16.1297 7.21758 17.2176 6.12969 17.5659 4.7364L17.6894 4.24254Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1704_12164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayforlead);
export default __webpack_public_path__ + "static/media/payforlead.fef5fa4726ce799b4c750a56c6d4adaa.svg";
export { ForwardRef as ReactComponent };